(() => {
  const normalise = (value = '') => value.toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/×/g, 'X').replace(/,/g, '.').replace(/\s+/g, ' ').trim();
  const ignoredSearchWords = new Set(['PROF','PROFS','PROFIL','PROFILS','PROFILE','PROFILES','BARRE','BARRES','ALU','ALUMINIUM','EN','DE','DU','DES','LE','LA','LES','SUR','MESURE']);
  const escapeRegex = (value = '') => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const searchTokens = (value = '') => normalise(value).replace(/[^A-Z0-9.]+/g, ' ').split(' ').filter(Boolean).map((token) => token.replace(/^(?:PROF|PROFIL|PROFILE)(?=\d)/, '')).filter(Boolean).filter((token) => !ignoredSearchWords.has(token));
  const tokenMatches = (haystack = '', token = '') => {
    if (!token) return true;
    if (/^\d+(?:\.\d+)?$/.test(token)) return new RegExp(`(^|[^0-9.])${escapeRegex(token)}(?=$|[^0-9.])`).test(haystack);
    const compactHaystack = haystack.replace(/[^A-Z0-9.]/g, '');
    const compactToken = token.replace(/[^A-Z0-9.]/g, '');
    return haystack.includes(token) || compactHaystack.includes(compactToken);
  };
  const queryMatches = (haystack = '', query = '') => {
    const tokens = searchTokens(query);
    return tokens.length === 0 || tokens.every((token) => tokenMatches(haystack, token));
  };
  const dimensionFrom = (value = '') => {
    const match = normalise(value).match(/(\d+(?:\.\d+)?)\s*X\s*(\d+(?:\.\d+)?)/);
    return match ? `${match[1]}×${match[2]}` : 'Spéciaux';
  };
  const dimensionValues = (dimension = '') => dimension === 'Spéciaux' ? [] : [...new Set(dimension.split('×'))];
  const featureFrom = (value = '') => {
    const text = normalise(value);
    if (/DEG/.test(text)) return 'deg';
    if (/WG\d*/.test(text)) return 'wg';
    if (/NVS/.test(text)) return 'nvs';
    if (/(?:^|[^A-Z0-9])\d+N(?:[^A-Z]|$)|X\d+N(?:[^A-Z]|$)/.test(text)) return 'n';
    if (/LEAN/.test(text)) return 'lean';
    if (/\dX\d+(?:\.\d+)?(?:L|LR|SL)(?:\s|$)|\d+(?:L|LR|SL)(?:\s|$)/.test(text)) return 'l';
    if (/\b(?:HR|R\d|D\d|TUBE|RAIL|GUID|PORTE|CADRE|BAC|POTENCE|ACCROCH|PREHENSION|PROTEC)\b/.test(text)) return 'special';
    return 'standard';
  };
  const featureLabels = { all:'Toutes les exécutions', standard:'Standard', l:'Version L', deg:'Angulaire DEG', wg:'Guide WG', n:'Version N', nvs:'Version NVS', lean:'Lean', special:'Spéciale' };
  const dimensionSort = (a, b) => {
    if (a === 'Spéciaux') return 1;
    if (b === 'Spéciaux') return -1;
    const pa = a.split('×').map(Number); const pb = b.split('×').map(Number);
    return (pa[0] - pb[0]) || (pa[1] - pb[1]);
  };
  const addOption = (select, value, label) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    select.appendChild(option);
  };

  const loadRemainingCards = async (section, grid) => {
    const totalCount = Number(section.dataset.totalCount || 0);
    let cards = [...section.querySelectorAll('[data-profile-card]')];
    if (!totalCount || cards.length >= totalCount) return cards;

    try {
      let nextPage = '2';
      let guard = 0;
      const seen = new Set(cards.map((card) => card.dataset.profileHandle));

      while (nextPage && guard < 20 && cards.length < totalCount) {
        guard += 1;
        const endpoint = new URL(window.location.pathname, window.location.origin);
        endpoint.searchParams.set('view', 'profile-cards');
        endpoint.searchParams.set('page', nextPage);

        const response = await fetch(endpoint.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) break;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = doc.querySelector('[data-profile-cards-batch]');
        if (!batch) break;

        batch.querySelectorAll('[data-profile-card]').forEach((node) => {
          const handle = node.dataset.profileHandle;
          if (handle && seen.has(handle)) return;
          if (handle) seen.add(handle);
          grid.appendChild(node);
        });

        cards = [...section.querySelectorAll('[data-profile-card]')];
        nextPage = batch.dataset.nextPage || '';
      }
    } catch (error) {
      console.warn('[CD13] Chargement des profilés additionnels impossible.', error);
    }

    return cards;
  };

  const initSection = async (section) => {
    const grid = section.querySelector('[data-profile-grid]');
    let cards = [...section.querySelectorAll('[data-profile-card]')];
    if (!cards.length) return;

    if (grid) cards = await loadRemainingCards(section, grid);

    const search = section.querySelector('[data-profile-search]');
    const majorSelect = section.querySelector('[data-profile-major]');
    const sectionSelect = section.querySelector('[data-profile-section]');
    const featureSelect = section.querySelector('[data-profile-feature]');
    const reset = section.querySelector('[data-profile-reset]');
    const resultCount = section.querySelector('[data-profile-result-count]');
    const resultHint = section.querySelector('[data-profile-result-hint]');
    const noResult = section.querySelector('[data-profile-no-result]');
    const advancedToggle = section.querySelector('[data-profile-filter-toggle]');
    const advancedFilters = section.querySelector('[data-profile-filters]');
    const finderToggle = section.querySelector('[data-profile-finder-toggle]');
    const finder = section.querySelector('[data-profile-finder]');

    if (finderToggle && finder) {
      finderToggle.addEventListener('click', () => {
        const open = finderToggle.getAttribute('aria-expanded') === 'true';
        finderToggle.setAttribute('aria-expanded', String(!open));
        finder.classList.toggle('is-open', !open);
      });
    }
    if (advancedToggle && advancedFilters) {
      advancedToggle.addEventListener('click', () => {
        const open = advancedToggle.getAttribute('aria-expanded') !== 'true';
        advancedToggle.setAttribute('aria-expanded', String(open));
        advancedFilters.hidden = !open;
      });
    }

    cards.forEach((card) => {
      card._dimension = dimensionFrom(card.dataset.profileTitle || card.dataset.profileSearchTerms);
      card._majorDimensions = dimensionValues(card._dimension);
      card._normalisedProduct = normalise(`${card.dataset.profileSearchTerms || ''} ${card._dimension}`);
      const select = card.querySelector('[data-profile-variant-select]');
      const options = select ? [...select.options] : [];
      options.forEach((option) => {
        option.dataset.feature = featureFrom(`${card.dataset.profileTitle} ${option.dataset.title}`);
        option.dataset.normalisedSearch = normalise(`${card.dataset.profileTitle} ${card._dimension} ${option.dataset.search}`);
      });
      card._profileOptions = options;
      card._profileSelect = select;
    });

    const allSections = [...new Set(cards.map((card) => card._dimension))].sort(dimensionSort);
    const allMajors = [...new Set(cards.flatMap((card) => card._majorDimensions))].sort((a, b) => Number(a) - Number(b));
    const featureOrder = ['standard','l','deg','wg','n','nvs','lean','special'];
    const cardFeatures = (card) => card._profileOptions.length ? card._profileOptions.map((option) => option.dataset.feature) : ['standard'];
    const cardHasFeature = (card, feature) => feature === 'all' || cardFeatures(card).includes(feature);

    const rebuildMajors = () => {
      const selectedFeature = featureSelect.value || 'all';
      const current = majorSelect.value;
      const compatibleMajors = [...new Set(cards
        .filter((card) => cardHasFeature(card, selectedFeature))
        .flatMap((card) => card._majorDimensions))]
        .sort((a, b) => Number(a) - Number(b));

      majorSelect.innerHTML = '';
      addOption(majorSelect, 'all', 'Toutes les dimensions');
      compatibleMajors.forEach((value) => addOption(majorSelect, value, `${value} mm`));
      if ([...majorSelect.options].some((option) => option.value === current)) majorSelect.value = current;
    };

    const rebuildSections = () => {
      const selectedMajor = majorSelect.value;
      const selectedFeature = featureSelect.value || 'all';
      const current = sectionSelect.value;
      sectionSelect.innerHTML = '';
      if (selectedMajor === 'all') {
        addOption(sectionSelect, 'all', 'Choisir d’abord une dimension');
        sectionSelect.disabled = true;
        return;
      }
      const available = allSections.filter((dimension) => cards.some((card) => (
        card._dimension === dimension && card._majorDimensions.includes(selectedMajor) && cardHasFeature(card, selectedFeature)
      )));
      addOption(sectionSelect, 'all', 'Toutes les sections');
      available.forEach((dimension) => addOption(sectionSelect, dimension, dimension));
      sectionSelect.disabled = false;
      if ([...sectionSelect.options].some((option) => option.value === current)) sectionSelect.value = current;
    };

    const rebuildFeatures = () => {
      const selectedMajor = majorSelect.value;
      const selectedSection = sectionSelect.value;
      const current = featureSelect.value;
      const help = section.querySelector('[data-profile-feature-help]');
      featureSelect.innerHTML = '';

      const compatibleCards = cards.filter((card) => {
        const majorMatches = selectedMajor === 'all' || card._majorDimensions.includes(selectedMajor);
        const sectionMatches = selectedSection === 'all' || card._dimension === selectedSection;
        return majorMatches && sectionMatches;
      });
      const compatibleFeatures = [...new Set(compatibleCards.flatMap(cardFeatures))];

      addOption(featureSelect, 'all', 'Toutes les exécutions compatibles');
      featureOrder
        .filter((value) => compatibleFeatures.includes(value))
        .forEach((value) => addOption(featureSelect, value, featureLabels[value]));

      featureSelect.disabled = false;
      if ([...featureSelect.options].some((option) => option.value === current)) featureSelect.value = current;
      if (help) {
        const count = compatibleFeatures.length;
        if (selectedSection !== 'all') help.textContent = `${count} exécution${count > 1 ? 's' : ''} compatible${count > 1 ? 's' : ''} avec cette section.`;
        else if (selectedMajor !== 'all') help.textContent = `${count} exécution${count > 1 ? 's' : ''} disponible${count > 1 ? 's' : ''} pour cette dimension.`;
        else help.textContent = 'Vous pouvez commencer par le type de profilé ou par ses dimensions.';
      }
    };

    const updateCard = (card, option) => {
      if (!option) return;
      card.querySelectorAll('[data-profile-link]').forEach((link) => link.setAttribute('href', option.dataset.url));
      const image = card.querySelector('.cd13-profile-card__image');
      const reference = card.querySelector('[data-profile-reference]');
      const priceHt = card.querySelector('[data-profile-price-ht]');
      const priceTtc = card.querySelector('[data-profile-price-ttc]');
      const availability = card.querySelector('[data-profile-availability]');
      if (reference) reference.textContent = option.dataset.reference || 'À renseigner';
      if (priceHt) priceHt.textContent = option.dataset.priceHt ? `${option.dataset.priceHt} HT` : '';
      if (priceTtc) priceTtc.textContent = option.dataset.priceTtc ? `${option.dataset.priceTtc} TTC` : '';
      if (availability) {
        const available = option.dataset.available === 'true';
        availability.textContent = available ? 'Disponible' : 'À confirmer';
        availability.classList.toggle('is-unavailable', !available);
      }
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.srcset = '';
        image.alt = option.dataset.imageAlt || image.alt;
      }
    };

    cards.forEach((card) => {
      card._profileSelect?.addEventListener('change', () => updateCard(card, card._profileSelect.selectedOptions[0]));
    });

    const apply = () => {
      const rawTerm = search?.value || '';
      const hasUsefulTerm = searchTokens(rawTerm).length > 0;
      const selectedMajor = majorSelect.value;
      const selectedSection = sectionSelect.value;
      const selectedFeature = featureSelect.value;
      let visibleCards = 0;
      let visibleVariants = 0;

      cards.forEach((card) => {
        const majorMatches = selectedMajor === 'all' || card._majorDimensions.includes(selectedMajor);
        const sectionMatches = selectedSection === 'all' || card._dimension === selectedSection;
        const productTermMatches = !hasUsefulTerm || queryMatches(card._normalisedProduct, rawTerm);
        let matches = [];

        if (card._profileOptions.length) {
          card._profileOptions.forEach((option) => {
            const featureMatches = selectedFeature === 'all' || option.dataset.feature === selectedFeature;
            const termMatches = !hasUsefulTerm || productTermMatches || queryMatches(`${card._normalisedProduct} ${option.dataset.normalisedSearch}`, rawTerm);
            const match = majorMatches && sectionMatches && featureMatches && termMatches;
            option.hidden = !match;
            option.disabled = !match;
            if (match) matches.push(option);
          });
        } else if (majorMatches && sectionMatches && (selectedFeature === 'all' || selectedFeature === 'standard') && productTermMatches) {
          matches = [null];
        }

        card.hidden = matches.length === 0;
        if (!card.hidden) {
          visibleCards += 1;
          visibleVariants += matches.length;
          if (card._profileSelect && card._profileSelect.selectedOptions[0]?.disabled) {
            card._profileSelect.value = matches[0].value;
            updateCard(card, matches[0]);
          }
        }
      });

      const active = selectedMajor !== 'all' || selectedSection !== 'all' || selectedFeature !== 'all' || Boolean(rawTerm.trim());
      if (reset) reset.hidden = !active;
      if (noResult) noResult.hidden = visibleCards !== 0;
      if (resultCount) resultCount.textContent = `${visibleCards} famille${visibleCards > 1 ? 's' : ''} · ${visibleVariants} variante${visibleVariants > 1 ? 's' : ''}`;
      if (resultHint) {
        const parts = [];
        if (selectedMajor !== 'all') parts.push(`${selectedMajor} mm`);
        if (selectedSection !== 'all') parts.push(selectedSection);
        if (selectedFeature !== 'all') parts.push(featureLabels[selectedFeature]);
        if (rawTerm.trim()) parts.push(`“${rawTerm.trim()}”`);
        resultHint.textContent = parts.length ? parts.join(' · ') : 'Tous les profilés disponibles';
      }
    };

    majorSelect.addEventListener('change', () => {
      rebuildSections();
      rebuildFeatures();
      apply();
    });
    sectionSelect.addEventListener('change', () => {
      rebuildFeatures();
      apply();
    });
    featureSelect.addEventListener('change', () => {
      rebuildMajors();
      rebuildSections();
      apply();
    });
    search?.addEventListener('input', apply);
    reset?.addEventListener('click', () => {
      if (search) search.value = '';
      featureSelect.value = 'all';
      rebuildMajors();
      rebuildSections();
      rebuildFeatures();
      apply();
    });

    rebuildMajors();
    rebuildSections();
    rebuildFeatures();
    apply();

    section.dispatchEvent(new CustomEvent('cd13:profile-cards-ready'));
  };

  document.querySelectorAll('[data-profile-collection]').forEach((section) => { initSection(section); });
})();
